import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {DrawerTriger} from "../drawer/Style";
import {closeDrawer, openDrawer} from "../../../redux/slice/opnerSlice";
import {createPortal} from "react-dom";
import Close from "../../../resources/icon/close-white.png";

function CommonDrawerContainer({onChange, title, type, auth, placeHolder, Component, ComponentProps, trigger, ...rest }) {

    const open =useSelector(state => state.opener.drawer[title]||false);
    const dispatch = useDispatch();

    const handleOpen = () => {
        if (!auth) return alert("권한이 없습니다.");
        dispatch(openDrawer({ key: title }));
    };

    const handleClose = () => {
        dispatch(closeDrawer({ key: title }));
    };

    const drawer = open ? (
        <div className={`drawer-view px-[2rem] py-[1rem] ${open ? 'slide-in' : ''}`} style={{width : "450px"}}>
            {/* Overlay: 바깥영역 클릭 시 닫기 */}
            <div className="bg-black/40 backdrop-blur-[1px] flex-1" onClick={handleClose} />

            {/* Panel: 우측에서 슬라이드 인 */}
            {/* Header */}
            <div className="flex drawer-title border-bb">
                <span className={`text-[20px] font-bold`}>{title}</span>
                <img src={Close} className="close-drawer2 cursor-pointer" onClick={handleClose}/>
            </div>

            {/* Content */}
            <div className="h-[calc(100%-56px)] overflow-auto">
                {Component ? (
                    <Component
                        {...ComponentProps}
                        onClose={handleClose}
                    />
                ) : (
                    <div className="text-gray-500">컴포넌트를 전달해 주세요.</div>
                )}
            </div>
        </div>
    ) : null;

    let triggerNode = null;
    if (typeof trigger === "function") {
        triggerNode = trigger({ open, openDrawer: handleOpen });
    } else if (React.isValidElement(trigger)) {
        const onClick = (e) => {
            trigger.props?.onClick?.(e);
            if (!e.defaultPrevented) handleOpen();
        };
        triggerNode = React.cloneElement(trigger, { onClick });
    } else {
        // 기본 트리거
        triggerNode = <DrawerTriger onClick={handleOpen}>선택</DrawerTriger>;
    }

    return (
        <div className={"block mr-2 my-[2px] w-full h-full"}>
            {triggerNode}

            <div className={`drawer-background ${open ? 'show' : 'none'}`} onClick={handleClose}></div>

            {open ? createPortal(drawer, document.body) : null}
        </div>

    );

}

export default CommonDrawerContainer;